export default function (entangledCode) {
    return {
        countdown: 60,
        canResend: false,
        resending: false,
        countdownTimer: null,
        lockoutTimer: null,
        eventCleanup: [],
        lockoutCountdown: 0,
        message: '',
        messageClass: '',
        code: ['','','','','',''],
        lockoutPeriod: 10, // window.config.lockoutPeriod,
        maxAttempts: 10, // window.config.maxAttempts,
        attempts: 0,
        codeError: false,
        startCountdown(seconds = 60) {
            clearInterval(this.countdownTimer);
            this.countdown = Math.max(0, Math.ceil(seconds));
            this.canResend = this.countdown === 0;
            if (this.canResend) {
                return;
            }
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                    this.canResend = true;
                }
            }, 1000);
        },
        formatTime(seconds) {
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
        },
        syncCode() {
            Livewire.emit('updateCode', [...this.code]);
        },
        focusInput(index) {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    const input = this.getCodeInputs()[index];

                    if (!input) {
                        return;
                    }

                    input.focus();

                    if (typeof input.select === 'function') {
                        input.select();
                    }
                });
            });
        },
        focusFirstInput() {
            this.focusInput(0);
        },
        moveToNext(event, index) {
            const value = String(event.target.value ?? '')
                .replace(/\D/g, '')
                .slice(-1);

            if (event.target.value !== value) {
                event.target.value = value;
            }

            this.updateCode(index, value);

            if (value !== '' && index < this.getCodeInputs().length - 1 && event.target.nextElementSibling) {
                event.target.nextElementSibling.focus();
            }
        },
        moveToPrevious(event, index) {
            if (event.key === 'Backspace' && event.target.value === '' && index > 0 && event.target.previousElementSibling) {
                event.preventDefault();

                const previousInput = event.target.previousElementSibling;
                previousInput.value = '';
                previousInput.focus();
                this.updateCode(index - 1, '');
                return;
            }

            this.updateCode(index, event.target.value);
        },
        resendCode() {
            if (this.resending || !this.canResend || this.isLockedOut()) {
                return;
            }
            this.resending = true;
            this.message = '';
            this.$wire.resendCodeEvent();
        },
        clearCodeInputs() {
            this.code = ['','','','','',''];
            const inputs = this.getCodeInputs();
            inputs.forEach(input => input.value = '');
            this.$wire.$set('code', [...this.code], false);
            this.focusFirstInput();
        },
        getCodeInputs() {
            return Array.from(this.$root.querySelectorAll('.code-input, .verify-otp__input'));
        },
        updateCode(index, value) {
            this.code[index] = value;
            this.syncCode();
        },
        isComplete() {
            return this.code.every(value => value !== '');
        },
        isLockedOut() {
            return this.lockoutCountdown > 0;
        },
        startLockoutCountdown() {
            clearInterval(this.lockoutTimer);
            if (this.lockoutCountdown <= 0) {
                this.lockoutTimer = null;
                return;
            }
            this.lockoutTimer = setInterval(() => {
                this.lockoutCountdown--;
                if (this.lockoutCountdown <= 0) {
                    clearInterval(this.lockoutTimer);
                    this.lockoutTimer = null;
                }
            }, 1000);
        },

        setupIOSOTPListener() {
            if (/iPhone|iPad/i.test(navigator.userAgent) && this.$refs.otpField) {
                this.$refs.otpField.addEventListener('input', (event) => this.handleIOSOTPInput(event));
            }
        },

        handleIOSOTPInput(event) {
            const code = event.target.value.trim();
            if (code.length === 6 && /^\d+$/.test(code)) {
                this.fillOTP(code);
            }
        },

        init() {
            // this.$watch('message', (value) => {
            //     this.message = value;
            // });

            if ('OTPCredential' in window && !navigator.userAgent.match(/(iPhone|iPad)/i)) {
                this.receiveOTP();
            }

            this.setupIOSOTPListener();

            const inputs = this.getCodeInputs();

            inputs.forEach(input => {
                input.addEventListener('paste', (event) => this.handlePaste(event));
            });

            this.focusFirstInput();

            const componentId = this.$wire.$id;
            this.eventCleanup.push(this.$wire.$hook('commit', ({ commit, respond, succeed }) => {
                if (commit.calls.some(call => call.method === 'resendCodeEvent')) {
                    respond(() => {
                        this.resending = false;
                    });
                }
                succeed(({ effects }) => {
                    const verified = effects.dispatches?.find(event => event.name === 'code-verified'
                        && event.params.id === componentId && event.params.status === 'success');
                    if (verified) {
                        Livewire.find(componentId)?.$call('onVerificationSuccess', verified.params.orderId ?? null);
                    }
                });
            }));

            this.eventCleanup.push(Livewire.on('resend-code', (data) => {
                if (data.id !== componentId) {
                    return;
                }
                this.resending = false;
                if (data.status !== 'success') {
                    this.message = data.message;
                    this.messageClass = 'alert-danger';
                    if (data.retryAfter > 0) {
                        this.startCountdown(data.retryAfter);
                    }
                    return;
                }
                this.startCountdown();
                this.clearCodeInputs();
                this.message = 'Новый проверочный код был отправлен на ваш телефон.';
                this.messageClass = 'alert-info';
                this.codeError = false;
            }));

            this.eventCleanup.push(Livewire.on('code-verified', (data) => {
                if (data.id !== componentId) {
                    return;
                }
                this.message = data.message;
                this.messageClass = data.status === 'success' ? 'alert-success' : 'alert-danger';

                if (data.status === 'error') {
                    this.codeError = true;
                    this.attempts++;
                    if (this.attempts >= this.maxAttempts) {
                        this.lockoutCountdown = this.lockoutPeriod;
                        this.startLockoutCountdown();
                        this.attempts = 0;
                    }
                } else {
                    this.codeError = false;
                }
            }));
        },

        destroy() {
            clearInterval(this.countdownTimer);
            clearInterval(this.lockoutTimer);
            this.countdownTimer = null;
            this.lockoutTimer = null;
            this.eventCleanup.forEach(cleanup => cleanup());
            this.eventCleanup = [];
        },

        async receiveOTP() {
            try {
                const content = await navigator.credentials.get({ otp: { transport: ['sms'] } });
                if (content && content.code) {
                    this.fillOTP(content.code);
                }
            } catch (error) {
                console.log('WebOTP API error', error);
            }
        },

        fillOTP(code) {
            const inputs = this.getCodeInputs();
            code.split('').forEach((digit, index) => {
                if (inputs[index]) {
                    inputs[index].value = digit;
                    this.code[index] = digit;
                }
            });
            this.syncCode();
        },

        handlePaste(event) {
            const pasteData = event.clipboardData.getData('text');
            const digits = pasteData.split('').filter(char => /\d/.test(char));

            if (digits.length === 6) {
                const inputs = this.getCodeInputs();
                inputs.forEach((input, index) => {
                    if (digits[index]) {
                        input.value = digits[index];
                        this.code[index] = digits[index];
                    }
                });
                this.syncCode();
                event.preventDefault();
            }
        },
    };
}
